(function () {
  'use strict';

  var activeDialog = null;

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function icon(path) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"></path></svg>';
  }

  function closeDialog() {
    if (!activeDialog) return;
    activeDialog.setAttribute('data-open', 'false');
    document.body.style.removeProperty('overflow');
    window.setTimeout(function () {
      if (activeDialog && activeDialog.getAttribute('data-open') === 'false') {
        activeDialog.remove();
        activeDialog = null;
      }
    }, 260);
  }

  function openFallbackDialog(data) {
    var dialog = document.createElement('div');
    dialog.className = 'jp-product-share-dialog';
    dialog.setAttribute('data-open', 'false');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Share product');
    dialog.innerHTML =
      '<div class="jp-product-share-dialog__sheet">' +
      '<div class="jp-product-share-dialog__header">' +
      '<h2 class="jp-product-share-dialog__title">Share to</h2>' +
      '<button type="button" class="jp-product-share-dialog__close" data-jp-share-close aria-label="Close">' +
      icon('M5 5l14 14M19 5 5 19') +
      '</button></div>' +
      '<div class="jp-product-share-dialog__product">' +
      (data.image ? '<img src="' + escapeHtml(data.image) + '" alt="">' : '') +
      '<p class="jp-product-share-dialog__product-title">' + escapeHtml(data.title) + '</p></div>' +
      '<div class="jp-product-share-dialog__actions">' +
      '<button type="button" class="jp-product-share-dialog__action" data-jp-share-copy>' +
      icon('M8 8h11v13H8zM5 16H4V3h11v1') + '<span>Copy Link</span></button>' +
      '<button type="button" class="jp-product-share-dialog__action" data-jp-share-facebook>' +
      icon('M14 8h3V4h-3c-2.2 0-4 1.8-4 4v2H7v4h3v6h4v-6h3l1-4h-4V8c0-.6.4-1 1-1z') +
      '<span>Facebook</span></button>' +
      '<button type="button" class="jp-product-share-dialog__action" data-jp-share-more>' +
      icon('M5 12h.01M12 12h.01M19 12h.01') + '<span>More</span></button>' +
      '</div></div>';
    document.body.appendChild(dialog);
    activeDialog = dialog;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      dialog.setAttribute('data-open', 'true');
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-jp-share-close]')) {
        closeDialog();
        return;
      }
      var copy = event.target.closest('[data-jp-share-copy]');
      if (copy) {
        navigator.clipboard
          .writeText(data.absoluteUrl)
          .then(function () {
            copy.querySelector('span').textContent = 'Copied';
          })
          .catch(function () {
            window.prompt('Copy this link', data.absoluteUrl);
          });
        return;
      }
      var facebook = event.target.closest('[data-jp-share-facebook]');
      if (facebook) {
        window.open(
          'https://www.facebook.com/sharer/sharer.php?u=' +
            encodeURIComponent(data.absoluteUrl),
          '_blank',
          'noopener,noreferrer'
        );
        return;
      }
      var more = event.target.closest('[data-jp-share-more]');
      if (more && navigator.share) {
        navigator.share({ title: data.title, url: data.absoluteUrl }).catch(function () {});
      }
    });
  }

  function share(button) {
    var title = button.dataset.jpShareTitle || document.title;
    var absoluteUrl = new URL(button.dataset.jpShareUrl || window.location.pathname, window.location.origin).href;
    var data = {
      title: title,
      absoluteUrl: absoluteUrl,
      image: button.dataset.jpShareImage || ''
    };
    if (navigator.share) {
      navigator.share({ title: title, text: title, url: absoluteUrl }).catch(function () {});
    } else {
      openFallbackDialog(data);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-jp-product-share]');
    if (button) {
      event.preventDefault();
      share(button);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDialog();
  });
}());